export enum DatePickerDateMode {
  Date = 'date',
  Week = 'week',
  Month = 'month',
  Year = 'year'
}
